var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.forceUpdateFlag
    ? _c(
        "div",
        { staticClass: "root-container" },
        [
          !_vm.viewLayout.length
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "align-items": "center",
                    "justify-content": "center",
                    height: "100%",
                  },
                },
                [
                  _c("img", {
                    staticClass: "empty-img",
                    attrs: {
                      src: require("@/assets/img/empty.png"),
                      alt: "empty",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "font-size": "14px", color: "#999" } },
                    [_vm._v("从左侧组件面板中点击或拖拽组件到画布中")]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "grid-layout",
            {
              ref: "gridlayout",
              staticClass: "gridlayout",
              attrs: {
                layout: _vm.viewLayout,
                "col-num": _vm.cols,
                responsive: _vm.responsive,
                "row-height": 30,
                "is-draggable": true,
                "is-resizable": true,
                "vertical-compact": true,
                "use-css-transforms": false,
              },
              on: {
                "update:layout": function ($event) {
                  _vm.viewLayout = $event
                },
              },
            },
            _vm._l(_vm.viewLayout, function (item) {
              return !item.hide
                ? _c(
                    "grid-item",
                    {
                      key: item._id + "_" + (item.tempKey || ""),
                      style: {
                        background:
                          item.styleConfig &&
                          item.styleConfig.commongConfig.customBackgroundColor
                            ? item.styleConfig.commongConfig.backgroundColor
                            : "#fff",
                      },
                      attrs: {
                        "drag-allow-from": ".bi-layout-drag-handle",
                        static: _vm.getPreviewFlag,
                        x: item.x,
                        y: item.y,
                        w: item.w,
                        h: item.h,
                        "drag-ignore-from": ".jzliu-bi-engine-middle-layer",
                        i: item.i,
                      },
                      on: {
                        resized: function ($event) {
                          return _vm.resizedEvent(item)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "bi-layout-drag-handle" }, [
                        _c("div", [_c("i", { staticClass: "el-icon-more" })]),
                        _vm._v(" "),
                        _c("div", [_c("i", { staticClass: "el-icon-more" })]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "jzliu-bi-engine-chart-warp grid-warp",
                          class: { shadow: item._id === _vm.cur._id },
                        },
                        [
                          _c("middle-layer", {
                            ref: "middle_" + item._id,
                            refInFor: true,
                            attrs: {
                              dashboardName: _vm.dashboardName,
                              chartDirection: _vm.chartDirection,
                              chartPreviewMode: _vm.chartPreviewMode,
                              previewMode: _vm.previewMode,
                              chartConfigHandler: _vm.chartConfigHandler,
                              chartData: item,
                            },
                            on: {
                              "sort-change": _vm.handleSortChange,
                              "drill-item-click": _vm.handleDrillItemClick,
                              "handle-table-command": _vm.handleTableCommand,
                              "table-page-change": _vm.handleTablePageChange,
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.chartSelect(item)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e()
            }),
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "gap" }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }